export default __webpack_public_path__ + "static/media/EntertainmentTonic.a68e0c9d4b276cc4ecc16bae9187147e.webp";